// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-info {
  padding: 32px 40px;
  overflow-y: auto;
  flex: 1;
  max-width: 900px;
}

/* ── Header ── */
.project-info-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 16px;
}

.project-info-name {
  font-size: 22px;
  font-weight: 600;
  color: var(--text-primary);
}
.project-info-sub {
  font-size: 14px;
  color: var(--text-secondary);
  margin-top: 2px;
}
.project-info-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  margin-top: 8px;
  font-size: 13px;
  color: var(--text-secondary);
}
.project-info-note {
  color: var(--text-secondary);
  font-size: 13px;
  margin-bottom: 20px;
  max-width: 600px;
}

/* ── Ship photo banner ── */
.ship-banner {
  position: relative;
  width: 100%;
  margin-bottom: 24px;
  cursor: pointer;
}
.ship-banner-empty {
  background: var(--bg-tertiary);
  border: 1px solid var(--border);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
}
.ship-banner-img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 3px;
}
.ship-banner-placeholder {
  font-size: 13px;
  color: var(--text-muted);
}
.ship-banner-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #fff;
  opacity: 0;
  transition: opacity 0.15s;
  border-radius: 3px;
}
.ship-banner:hover .ship-banner-overlay { opacity: 1; }

/* ── Notices ── */
.notices-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 20px;
}
.notice {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  border-left: 3px solid;
  font-size: 13px;
}
.notice-yellow {
  background: rgba(220, 170, 0, 0.1);
  border-left-color: #dcaa00;
}
.notice-blue {
  background: rgba(55, 148, 255, 0.1);
  border-left-color: #3794ff;
}
.notice-red {
  background: rgba(244, 71, 71, 0.1);
  border-left-color: var(--red);
}
.notice-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
}
.notice-yellow .notice-icon { background: #dcaa00; color: #1e1e1e; }
.notice-red    .notice-icon { background: var(--red); color: #fff; }
.notice-blue   .notice-icon { background: #3794ff; color: #fff; }
.notice-text { flex: 1; color: var(--text-primary); }
.notice-input {
  flex: 1;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--border);
  color: var(--text-primary);
  font-size: 13px;
  padding: 1px 0;
  outline: none;
}
.notice-actions {
  display: flex;
  gap: 2px;
  opacity: 0;
  transition: opacity 0.1s;
}
.notice:hover .notice-actions { opacity: 1; }
.notice-new .notice-actions { opacity: 1; }

.notice-add-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--text-muted);
  padding: 4px 0;
  width: fit-content;
}
.notice-add-btn:hover { color: var(--text-primary); }

/* ── Stats ── */
.project-stats-section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
  margin-bottom: 8px;
}
.project-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}
.stat-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.stat-value {
  font-size: 26px;
  font-weight: 600;
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}
.stat-unit  { font-size: 13px; font-weight: 400; color: var(--text-secondary); }
.stat-label { font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--text-muted); }

/* ── Vessel specs ── */
.specs-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 48px;
  align-items: start;
  margin-bottom: 8px;
}

.specs-section { margin-bottom: 28px; }
.specs-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--border);
}

/* ── Spec line (dotted leaders) ── */
.spec-line {
  display: flex;
  align-items: baseline;
  padding: 4px 0;
  gap: 8px;
}
.spec-line-label {
  flex-shrink: 0;
  font-size: 13px;
  color: var(--text-secondary);
  min-width: 130px;
}
.spec-line-dots {
  flex: 1;
  border-bottom: 1px dotted var(--text-muted);
  margin-bottom: 3px;
  min-width: 12px;
}
.spec-line-value {
  flex-shrink: 1;
  min-width: 0;
  font-size: 13px;
  color: var(--text-primary);
  font-weight: 500;
  text-align: right;
  font-variant-numeric: tabular-nums;
  word-break: break-word;
  overflow-wrap: break-word;
}
.spec-line-unit {
  font-size: 11px;
  font-weight: 400;
  color: var(--text-secondary);
  margin-left: 2px;
}

.flag-emoji {
  font-size: 16px;
  margin-right: 5px;
  line-height: 1;
  vertical-align: middle;
}

/* ── Actions ── */
.project-info-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── Mobile ── */
@media (max-width: 768px), (hover: none) and (max-width: 1024px) {
  .project-info { padding: 16px; max-width: 100%; }
  .project-info-header { flex-direction: column; gap: 12px; align-items: flex-start; }
  .project-info-name { font-size: 18px; }

  .specs-columns { grid-template-columns: 1fr; gap: 0; }
  .specs-columns > * { grid-column: 1 !important; grid-row: unset !important; }
  .spec-line-label { min-width: 110px; font-size: 12px; }
  .project-stats-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; }
  .stat-value { font-size: 22px; }
  .notices-section { margin-bottom: 16px; }
}

/* ── Form ── */
.form-section { margin-bottom: 20px; }
.form-section-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--border);
}
`, "",{"version":3,"sources":["webpack://./src/components/projects/Projects.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;AACA,0CAA0C,UAAU,EAAE;;AAEtD,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,sBAAsB,EAAE,WAAW,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,WAAW,EAAE;AAChE,eAAe,OAAO,EAAE,0BAA0B,EAAE;AACpD;EACE,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;EACtC,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;AACA,gCAAgC,UAAU,EAAE;AAC5C,8BAA8B,UAAU,EAAE;;AAE1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;AACA,wBAAwB,0BAA0B,EAAE;;AAEpD,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;AACpC;AACA,cAAc,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AAC/E,cAAc,eAAe,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,wBAAwB,EAAE;;AAE5G,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iBAAiB,mBAAmB,EAAE;AACtC;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB,aAAa,EAAE,eAAe,EAAE;EAChD,uBAAuB,sBAAsB,EAAE,SAAS,EAAE,uBAAuB,EAAE;EACnF,qBAAqB,eAAe,EAAE;;EAEtC,iBAAiB,0BAA0B,EAAE,MAAM,EAAE;EACrD,qBAAqB,yBAAyB,EAAE,0BAA0B,EAAE;EAC5E,mBAAmB,gBAAgB,EAAE,eAAe,EAAE;EACtD,sBAAsB,qCAAqC,EAAE,QAAQ,EAAE;EACvE,cAAc,eAAe,EAAE;EAC/B,mBAAmB,mBAAmB,EAAE;AAC1C;;AAEA,eAAe;AACf,gBAAgB,mBAAmB,EAAE;AACrC;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC","sourcesContent":[".project-info {\n  padding: 32px 40px;\n  overflow-y: auto;\n  flex: 1;\n  max-width: 900px;\n}\n\n/* ── Header ── */\n.project-info-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 16px;\n}\n\n.project-info-name {\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n.project-info-sub {\n  font-size: 14px;\n  color: var(--text-secondary);\n  margin-top: 2px;\n}\n.project-info-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 20px;\n  margin-top: 8px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n.project-info-note {\n  color: var(--text-secondary);\n  font-size: 13px;\n  margin-bottom: 20px;\n  max-width: 600px;\n}\n\n/* ── Ship photo banner ── */\n.ship-banner {\n  position: relative;\n  width: 100%;\n  margin-bottom: 24px;\n  cursor: pointer;\n}\n.ship-banner-empty {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 60px;\n}\n.ship-banner-img {\n  width: 100%;\n  height: auto;\n  display: block;\n  border-radius: 3px;\n}\n.ship-banner-placeholder {\n  font-size: 13px;\n  color: var(--text-muted);\n}\n.ship-banner-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  color: #fff;\n  opacity: 0;\n  transition: opacity 0.15s;\n  border-radius: 3px;\n}\n.ship-banner:hover .ship-banner-overlay { opacity: 1; }\n\n/* ── Notices ── */\n.notices-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 20px;\n}\n.notice {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  border-left: 3px solid;\n  font-size: 13px;\n}\n.notice-yellow {\n  background: rgba(220, 170, 0, 0.1);\n  border-left-color: #dcaa00;\n}\n.notice-blue {\n  background: rgba(55, 148, 255, 0.1);\n  border-left-color: #3794ff;\n}\n.notice-red {\n  background: rgba(244, 71, 71, 0.1);\n  border-left-color: var(--red);\n}\n.notice-icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 900;\n  font-size: 13px;\n  line-height: 1;\n  cursor: pointer;\n}\n.notice-yellow .notice-icon { background: #dcaa00; color: #1e1e1e; }\n.notice-red    .notice-icon { background: var(--red); color: #fff; }\n.notice-blue   .notice-icon { background: #3794ff; color: #fff; }\n.notice-text { flex: 1; color: var(--text-primary); }\n.notice-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid var(--border);\n  color: var(--text-primary);\n  font-size: 13px;\n  padding: 1px 0;\n  outline: none;\n}\n.notice-actions {\n  display: flex;\n  gap: 2px;\n  opacity: 0;\n  transition: opacity 0.1s;\n}\n.notice:hover .notice-actions { opacity: 1; }\n.notice-new .notice-actions { opacity: 1; }\n\n.notice-add-btn {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: var(--text-muted);\n  padding: 4px 0;\n  width: fit-content;\n}\n.notice-add-btn:hover { color: var(--text-primary); }\n\n/* ── Stats ── */\n.project-stats-section-label {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n}\n.project-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 12px;\n  margin-bottom: 20px;\n}\n.stat-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.stat-value {\n  font-size: 26px;\n  font-weight: 600;\n  color: var(--text-primary);\n  font-variant-numeric: tabular-nums;\n}\n.stat-unit  { font-size: 13px; font-weight: 400; color: var(--text-secondary); }\n.stat-label { font-size: 11px; text-transform: uppercase; letter-spacing: 0.06em; color: var(--text-muted); }\n\n/* ── Vessel specs ── */\n.specs-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 48px;\n  align-items: start;\n  margin-bottom: 8px;\n}\n\n.specs-section { margin-bottom: 28px; }\n.specs-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  margin-bottom: 6px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--border);\n}\n\n/* ── Spec line (dotted leaders) ── */\n.spec-line {\n  display: flex;\n  align-items: baseline;\n  padding: 4px 0;\n  gap: 8px;\n}\n.spec-line-label {\n  flex-shrink: 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n  min-width: 130px;\n}\n.spec-line-dots {\n  flex: 1;\n  border-bottom: 1px dotted var(--text-muted);\n  margin-bottom: 3px;\n  min-width: 12px;\n}\n.spec-line-value {\n  flex-shrink: 1;\n  min-width: 0;\n  font-size: 13px;\n  color: var(--text-primary);\n  font-weight: 500;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.spec-line-unit {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--text-secondary);\n  margin-left: 2px;\n}\n\n.flag-emoji {\n  font-size: 16px;\n  margin-right: 5px;\n  line-height: 1;\n  vertical-align: middle;\n}\n\n/* ── Actions ── */\n.project-info-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* ── Mobile ── */\n@media (max-width: 768px), (hover: none) and (max-width: 1024px) {\n  .project-info { padding: 16px; max-width: 100%; }\n  .project-info-header { flex-direction: column; gap: 12px; align-items: flex-start; }\n  .project-info-name { font-size: 18px; }\n\n  .specs-columns { grid-template-columns: 1fr; gap: 0; }\n  .specs-columns > * { grid-column: 1 !important; grid-row: unset !important; }\n  .spec-line-label { min-width: 110px; font-size: 12px; }\n  .project-stats-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; }\n  .stat-value { font-size: 22px; }\n  .notices-section { margin-bottom: 16px; }\n}\n\n/* ── Form ── */\n.form-section { margin-bottom: 20px; }\n.form-section-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  margin-bottom: 10px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid var(--border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
